<div class="social-media-wrapper" [class.square-buttons]="isSquare">
  <ul>
    @for (link of socialLinks(); track link.url) {
      <li>
        <a [href]="link.url" class="m-2" target="_blank" rel="noopener"
           [attr.aria-label]="link.label || link.platform">
          <fa-icon class="social-icon" [icon]="iconFor(link.icon)"></fa-icon>
        </a>
      </li>
    }
  </ul>
</div>
